<template>
    <div class="card mt-12">

        <div class="card-header card-header bg-primary text-white h4 m-0">
            <page-title :title="title"></page-title>
        </div>
        <div class="card-header">
            <div class="btn-toolbar justify-content-between mt-3" role="toolbar">
                <div class="input-group col-lg-6 col-md-12">
                    <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters"
                           type="text" class="form-control" aria-label="Mass search input"
                           aria-describedby="massSearch">
                    <button class="btn btn-secondary" @click.stop="massSearch">
                        <i class="fas fa-search"></i>
                        {{ $t('buttons.search.btnText') }}
                    </button>
                    <button class="btn btn-secondary"
                            @click.stop="clearFilters">
                        <i class="fas fa-times"></i>
                        {{ $t('buttons.clearFilters.btnText') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="card-body">
            <kendo-datasource ref="datasource1"
                              :transport="transportSettings"
                              :schema-model-id="'id'"
                              :schema-model-fields="schemaModelFields"
                              :schema-total="'total'"
                              :schema-data="'data'"
                              :page-size='defaultGridRows'
                              :server-paging="true"
                              :server-sorting="true"
                              :server-filtering="true"
                              :error="dataSourceError"
                              :requestEnd="datasorceRequestEnd">
            </kendo-datasource>

            <kendo-grid ref="grid"
                        :data-source-ref="'datasource1'"
                        :pageable="gridOptions.pageable"
                        :navigatable="gridOptions.navigatable"
                        :editable="gridOptions.editable"
                        :filterable="gridOptions.filterable"
                        :reorderable="gridOptions.reorderable"
                        :resizable="gridOptions.resizable"
                        :groupable="gridOptions.groupable"
                        :allow-copy="gridOptions.allowCopy"
                        :column-menu="gridOptions.columnMenu"
                        :sortable-mode="gridOptions.sortable.mode"
                        :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                        :sortable-show-indexes="gridOptions.sortable.showIndexes"
                        :selectable="gridOptions.selectable"
                        :scrollable="gridOptions.scrollable"
                        :toolbar="toolbar"
                        :excel="gridOptions.excel"
                        :pdf="gridOptions.pdf"
                        :data-bound="dataBound">

                <kendo-grid-column :field="'id'"
                                   :width="100"
                                   :hidden="true"
                                   :title="$t('person.gridHeaders.id')">
                </kendo-grid-column>
                <kendo-grid-column :title="$t('actions')"
                                   field="btnsColumn"
                                   :sortable="false"
                                   :filterable="false"
                                   :template="btnsTemplate"
                                   :width="150">
                </kendo-grid-column>
                <kendo-grid-column :field="'userName'"
                                   :expandable="true"
                                   :title="$t('person.gridHeaders.username')">
                </kendo-grid-column>
                <kendo-grid-column :field="'email'"
                                   :title="$t('person.gridHeaders.email')">
                </kendo-grid-column>
                <kendo-grid-column :field="'roles'"
                                   :title="$t('person.gridHeaders.roles')">
                </kendo-grid-column>
                <kendo-grid-column :field="'roleModels'"
                                   :title="' '"
                                   :template="rolesCellTemplate"
                                   :editor="rolesDropDownEditor"
                                   :filterable="false"
                                   :hidden="true">
                </kendo-grid-column>
                <kendo-grid-column :field="'deleted'"
                                   :title="$t('person.gridHeaders.deleted')"
                                   :width="130"
                                   :template="deletedCellTemplate">
                </kendo-grid-column>
                <kendo-grid-column :field="'updatedAtUtc'"
                                   :title="$t('person.gridHeaders.updatedAtUtc')"
                                   :width="150"
                                   :format="customDatetimeFormat">
                </kendo-grid-column>
                <kendo-grid-column :field="'updatedByUsername'"
                                   :title="$t('person.gridHeaders.updatedBy')"
                                   :width="150">
                </kendo-grid-column>
            </kendo-grid>
        </div>
        <UserCreateModal :show="showUserCreate" @onClose="onUserCreateClose" @onSave="onUserCreate"></UserCreateModal>
        <UserEditModal v-model="userModel" :show="showUserEdit" @onClose="onUserEditClose"
                       @onSave="onUserEdit"></UserEditModal>
    </div>

</template>

<script>
    import $ from 'jquery'; // това се изисква за да се вмъкват kendo ui компоненти. Виж метод parentIdDropDownEditor
    import Vue from 'vue';
    import JSZip from 'jszip'
    import BtnsTemplate from "@/components/grid/StandardBtnsTemplate";
    import UserEditModal from '@/components/user/edit.modal'
    import UserCreateModal from '@/components/user/create.modal'
    import userService from '@/services/user.service';
    import PageTitle from '@/components/common/PageTitle';
    import { mapGetters } from 'vuex';

    /*
    Renders the grid in "DejaVu Sans" font family, which is
    declared in kendo.common.css. It also declares the paths to the
    fonts below using <tt>kendo.pdf.defineFont</tt>, because the
    stylesheet is hosted on a different domain.
    */
    kendo.pdf.defineFont({
        "DejaVu Sans": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans.ttf",
        "DejaVu Sans|Bold": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Bold.ttf",
        "DejaVu Sans|Bold|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "DejaVu Sans|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "WebComponentsIcons": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/glyphs/WebComponentsIcons.ttf"
    });

    export default {
        components: {
            UserEditModal,
            UserCreateModal,
            PageTitle
        },
        props: {
            expandFirstMasterDetails: {
                default: false,
                type: Boolean
            }
        },
        data() {
            return {
                title: '',
                componentName: "personByRoleGrid", // Трябва на компонентата за бутоните за дашборд настройките
                titleKey: 'administration.user.grid.title', // Трябва на компонентата за бутоните за дашборд настройките
                defaultGridRows: this.$store.getters.defaultGridRows,
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                searchQuery: '',
                showPersonEdit: false,
                personModel: null,
                showPersonDetails: false,
                userModel: null,
                showUserEdit: false,
                showUserCreate: false,
                schemaModelFields: {
                    id: { name: 'id', type: 'string', editable: false, nullable: false, visible: true },
                    userName: {
                        name: 'userName',
                        type: 'string',
                        editable: true,
                        nullable: true,
                        visible: true,
                        validation: { required: true, type: 'text' }
                    },
                    email: {
                        name: 'email',
                        type: 'string',
                        editable: true,
                        nullable: true,
                        visible: true,
                        validation: { required: true, type: 'email' }
                    },
                    roles: { name: 'roles', type: 'string', editable: false, nullable: true, visible: false },
                    roleModels: {
                        name: 'roleModels',
                        type: 'object',
                        editable: true,
                        nullable: true,
                        visible: true,
                        defaultValue: { id: 0, name: 'Избери...', normalizedName: '' }
                    },
                    deleted: { name: 'deleted', type: 'boolean', editable: false, nullable: true, visible: true },
                    updatedAtUtc: {
                        name: 'updatedAtUtc',
                        type: 'date',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    updatedByUsername: {
                        name: 'updatedByUsername',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + `/api/roles/personGridByRole/${this.$route.params.id}`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    editable: {
                        mode: 'popup', /* inline, popup */
                        window: {
                            title: this.$tc('administration.user.title', 2),
                            animation: true
                        },
                        move: true
                    },
                    excel: {
                        fileName: 'Users.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    },
                },
                working: false
            };
        },
        methods: {
            dataBound(ev) {
                if (this.expandFirstMasterDetails) {
                    ev.sender.expandRow(ev.sender.tbody.find('tr.k-master-row').first())
                }
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    // Викаме POST action за листване на номенклатурите и трябва да сериализираме
                    // options. Така се предава информация за take, skip , page и списък с обекти
                    // описващи сортирането
                    return kendo.stringify(options);
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            onUserEditClose() {
                this.showUserEdit = false;
                this.userModel = null;
            },
            onUserEdit(item) {
                this.showUserEdit = false;
                this.userModel = null;
                this.refresh();
            },
            onUserCreateClose() {
                this.showUserCreate = false;
                this.userModel = null;
            },
            onUserCreate(item) {
                this.showUserCreate = false;
                this.userModel = null;
                this.refresh();
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.grid,
                        btns: [
                            {
                                name: "edit",
                                text: "",
                                tooltip: this.$t('buttons.edit.btnText'),
                                class: 'btn btn-primary',
                                icon: "fas fa-edit",
                                show: this.hasUpdateRights,
                                clickHandler: this.editBtnClick
                            },
                            // {
                            //     name: "management",
                            //     text: "",
                            //     tooltip: this.$t('buttons.management.btnText'),
                            //     class: 'btn btn-primary',
                            //     icon: "fas fa-user-cog",
                            //     show: this.hasUpdateRights,
                            //     clickHandler: this.manageBtnClick
                            // },
                            {
                                name: "delete",
                                text: "",
                                tooltip: this.$t('buttons.delete.btnText'),
                                class: 'btn btn-danger',
                                icon: "fas fa-times",
                                show: this.hasDeleteRights,
                                clickHandler: this.deleteBtnClick
                            }
                        ]
                    }
                };
            },
            editBtnClick(args) {
                if (!this.hasUpdateRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.showUserEditModal(args.id);
            },
            getCurrentRole() {
                this.$http.get('api/roles/list').then(result => {
                    if (result && result.data && result.data.roles) {
                        let role = result.data.roles.find(el => el.id === this.$route.params.id);
                        if (role) {
                            this.title = this.$t('sideMenu.userGroup') + ' - ' + role.name;
                        }
                    }
                })
            },
            showUserEditModal(id) {
                userService
                    .getById(id)
                    .then(response => {
                        let model = response.data;
                        if (model) {
                            this.userModel = model;
                            this.showUserEdit = true;
                        } else {
                            this.userModel = null;
                            this.showUserEdit = false;
                        }
                    })
                    .catch(error => {
                        this.userModel = null;
                        this.showUserEdit = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            manageBtnClick(args) {
                if (!this.hasUpdateRights) {
                    return this.$router.push(`/unauthorized`);
                }

                let routeData = this.$router.resolve({ name: 'administration/user/manage', params: { id: args.id } });
                window.open(routeData.href, '_blank');
            },
            deleteBtnClick(args) {
                kendo.confirm(`${this.$t('administration.user.confirmations.delete')} '${args.userName}'?`)
                    .then(function () {
                        userService
                            .delete(args.id)
                            .then(response => {
                                this.refresh();
                                this.$vs.notify({
                                    title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                                    text: this.$helpers.responseMessage(response),
                                    color: 'success',
                                    time: this.$store.getters.notificationDuration
                                });
                            })
                            .catch(error => {
                                this.$vs.notify({
                                    title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                    text: this.$helpers.errorText(error),
                                    color: this.$helpers.errorColor(error),
                                    time: this.$store.getters.notificationDuration
                                })
                            });
                    }.bind(this));
            },
            rolesDropDownEditor: function (container, options) {
                $('<input name="' + options.field + '"/> id="' + options.field + '"')
                    .appendTo(container)
                    .kendoMultiSelect({
                        autoBind: false,
                        dataTextField: 'name',
                        dataValueField: "id",
                        optionLabel: this.$t('selectTariffGroup'),
                        dataSource: {
                            transport: {
                                read: {
                                    url: this.$store.getters.baseUrl + '/api/roles/getAllModels',
                                    dataType: 'json',
                                    type: 'GET',
                                    contentType: 'application/json',
                                    beforeSend: this.beforeSend
                                },
                            }
                        }
                    });
            },
            rolesCellTemplate: function (dataItem) {
                return kendo.htmlEncode("");

                // if (dataItem.roleModels === null || !Array.isArray(dataItem.roleModels) || dataItem.roleModels.lenght <= 0) {
                // }

                // let templateHtml = "";
                // dataItem.roleModels.forEach(item => {
                //    templateHtml += '<span class="badge badge-secondary">' + kendo.htmlEncode(item.name) + '</span>';
                // });

                // return templateHtml;
            },
            deletedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.deleted ? 'badge-danger' : 'badge-success') + '">' + kendo.htmlEncode(dataItem.deleted ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            refresh() {
                const ds = this.$refs.datasource1.kendoWidget();
                if (ds) {
                    ds.read();
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            datasorceRequestEnd(e) {
                if (e.type === "create" && e.response) {
                    this.refresh()
                } else if (e.type === "update" && e.response) {
                    this.refresh()
                } else if (e.type === "destroy" && e.response) {
                    this.refresh()
                }
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            hasParentCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.hasParent ? 'badge-warning' : 'badge-secondary') + '">' + kendo.htmlEncode(dataItem.hasParent ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            createBtnClick() {
                if (!this.hasCreateRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.showUserCreate = true;
            },
        },
        mounted: function () {
            this.getCurrentRole();
        },
        created: function () {
            window.JSZip = JSZip // Необходимо е за да работи експорта в excel
        },
        computed: {
            ...mapGetters(['dateTimeFormat', 'isEnVersion']),
            customDatetimeFormat() {
                return `{0:${this.dateTimeFormat}}`;
            },
            token: function () {
                return this.$store.getters.authToken;
            },
            toolbar: function () {
                return [{ name: 'excel', text: this.$t('buttons.excelExport.tooltipText') }]
            },
            hasReadRights() {
                return this.$store.getters.claims.aspNetUser.read;
            },
            hasUpdateRights() {
                return this.$store.getters.claims.aspNetUser.update;
            },
            hasDeleteRights() {
                return this.$store.getters.claims.aspNetUser.delete;
            },
            hasCreateRights() {
                return this.$store.getters.claims.aspNetUser.create;
            }
        }
    }
</script>

<style scoped>
    .btn {
        margin-right: 10px;
        margin-left: 5px;
    }

    .checkbox {
        margin-right: 5px;
    }

    .selectFile {
        display: none;
    }

    .inlineForm {
        display: inline;
    }

    /*
        Use the DejaVu Sans font for display and embedding in the PDF file.
        The standard PDF fonts have no support for Unicode characters.
    */
    .k-pdf-export .k-grid {
        font-family: "DejaVu Sans", "Arial", sans-serif;
    }

    .k-pdf-export .k-filterable .k-grid-filter {
        display: none;
    }

    .k-pdf-export .k-with-icon .k-header-column-menu {
        display: none;
    }

    .k-grid .k-grid-header .k-header .k-link {
        height: auto;
    }

    .k-grid .k-grid-header .k-header {
        white-space: normal;
    }

    .k-grid-edit, .k-grid-details, .k-grid-delete, .k-grid-pdf, .k-grid-excel {
        padding: 0;
        margin-bottom: 2px;
    }
</style>

<style lang="scss">
    tr.left-border-danger {
        &:hover {
            color: rgba(255, 0, 0, 0.7) !important;
        }

        td:first-child {
            border-left: 5px solid rgba(255, 0, 0, 0.5) !important;
        }

    }

    tr.left-border-blue {
        &:hover {
            color: #3498db !important;
        }

        td:first-child {
            border-left: 5px solid #3498db !important;
        }

    }

    tr.left-border-green {
        &:hover {
            color: #4caf50 !important;
        }

        td:first-child {
            border-left: 5px solid #4caf50 !important;
        }
    }
</style>
